import React, { useState, useEffect } from "react";
import { Box, Button, Stack, Typography, IconButton, Tooltip, Drawer } from "@mui/material";
import '../../Laboratory/Purchase/purchase.css';
import { ImagePaths } from '../../../Utility/ImagePaths';
import { DataGrid } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { AmountFormat, CheckAccessFunc, formatDate } from "../../../Components/CommonFunctions/CommonFunctions";
import { CommonGridToolBarWithFilterText, CommonGridToolBarWithFilterTextCustom } from "../../../Components/Common Components/CommonComponents";
import { CurrencySymbol } from "../../../Utility/Constants";
import { AmountsCard } from "../../../Components/CommonCards/CommonCards";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import CommonDatePicker from "../../../Components/Common Components/CommonDatePicker";
import { DateTime } from "luxon";

const CorporateProvider = () => {
    const { t } = useTranslation();
    const [CorporateData, setCorporateData] = useState([]);
    const [pageSize, setPageSize] = useState(30);
    const [currentPage, setCurrentPage] = useState(0);
    const [isLoader, setIsLoader] = useState(false);
    const [states, setStates] = useState({
        totalClaimAmount: 0,
        totalReceivedAmount: 0,
        totalOutstanding: 0,
        totalCount: 0,
        disableBtn: false,
        pageLength: 0
    });
    const [Filter, setFilter] = useState({
        openFilter: false,
        fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        dateIndex: 1,
    });
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const history = useHistory();

    useEffect(() => {
        getCorporateList();
    }, []);

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const msgClose = () => {
        seterrorMsgText('');
        seterrorMsg(false);
    }

    const getCorporateList = () => {
        try {
            setIsLoader(true);
            setCorporateData([]);

            RestAPIService.getAll(`${Serviceurls.CORPORATE_PROVIDER_GET}?from_date=${Filter.fromDate}&to_date=${Filter.toDate}`)
                .then(response => {
                    if (response.data.status === "success") {
                        const list = response.data.data?.map((item, i) => ({ ...item, sno: i + 1 })) || [];
                        setCorporateData(list || []);
                        setStates(prev => ({
                            ...prev,
                            totalCount: response?.data?.total_count || 0,
                            totalClaimAmount: response?.data?.total_claimed_amount || 0,
                            totalOutstanding: response?.data?.total_pending_amount || 0,
                            totalReceivedAmount: response?.data?.total_received_amount || 0,
                            pageLength: response.data?.no_of_pages || 0
                        }));
                    }
                    setIsLoader(false);
                })
                .catch(error => {
                    setIsLoader(false);
                    if (error.response?.data?.status === "fail") {
                        errorMessage(error.response.data.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message)
            setIsLoader(false);
        }
    };

    const handleView = (event, values) => {
        history.push({ pathname: "/CreditSettlement/Corporate/Payment", state: { companyData: values?.row, fromDate: Filter.fromDate, toDate: Filter.toDate, dateIndex: Filter.dateIndex, AllData: (Filter.fromDate == '' && Filter.toDate == '') ? true : false } });
    };

    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const getCorpDetailedBillPrint = (id) => {
        try {
            setStates(prev => ({ ...prev, disableBtn: true }));
            RestAPIService.getAll(`${Serviceurls.CORPORATE_PROVIDER_GET}?corporate_id=${id || ""}&export_type=pdf`).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    setStates(prev => ({ ...prev, disableBtn: false }));
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        errorMessage(error.response?.data?.message);
                    } else {
                        errorMessage(error.message);
                    }
                    setStates(prev => ({ ...prev, disableBtn: false }));
                });
        } catch (error) {
            errorMessage(error.message);
            setStates(prev => ({ ...prev, disableBtn: false }));
        }
    };

    const printCorpPaymentList = (id) => {
        try {
            setStates(prev => ({ ...prev, disableBtn: false }));
            RestAPIService.getAll(`${Serviceurls.PURCHASE_VENDOR_PAYMENT_PRINT}?vendor_id=${id ? id : ""}&export=pdf`)
                .then(response => {
                    const file = new Blob([response.data], { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    setStates(prev => ({ ...prev, disableBtn: false }));
                })
                .catch((error) => {
                    if (error.response?.data?.message) {
                        errorMessage(error.response?.data?.message);
                    } else {
                        errorMessage(error.message);
                    }
                    setStates(prev => ({ ...prev, disableBtn: false }));
                })
        } catch (error) {
            errorMessage(error.message)
            setStates(prev => ({ ...prev, disableBtn: false }));
        }
    }

    const getCorpPaymentexcel = () => {
        try {
            RestAPIService.excelGet(`${Serviceurls.CORPORATE_PROVIDER_GET}?from_date=${Filter.fromDate}&to_date=${Filter.toDate}&page_size=${+pageSize}&page_number=${+currentPage + 1}&export_type=excel`)
                .then(response => {
                    if (response.data) {
                        const pom = document.createElement('a');
                        const csvContent = response.data;
                        const filename = response.headers["content-disposition"].split("filename=")[1];
                        const blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' });
                        const url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename || 'registry.xlsx');
                        pom.click();
                    }
                }).catch(error => {
                    errorMessage(error.response.data.message);
                });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const closeFilter = () => {
        setFilter(prev => ({ ...prev, openFilter: false }));
    }

    const FilterDate = (fromDate, toDate, dateIndex) => {
        setFilter(prev => ({
            ...prev,
            fromDate: fromDate,
            toDate: toDate,
            dateIndex: dateIndex
        }));
    }

    const renderFilterScreen = () => {
        return (
            <Box component="div" className='eMed_rts_filter_container'>
                <Box component="div" className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t('Filter')}</Typography>
                    <Button
                        emed_tid="vndpay_close"
                        onClick={() => setFilter(prev => ({ ...prev, openFilter: false }))}
                        className='eMed_usrconf_btn'
                    >
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>

                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter_vendor'>
                        <CommonDatePicker
                            FromDate={Filter.fromDate}
                            ToDate={Filter.toDate}
                            DateIndex={Filter.dateIndex}
                            SelectedDates={FilterDate}
                            HideAllMenu={false}
                        />
                    </Box>
                </Box>

                <Stack spacing={2} direction="row" className='eMed_rts_btn' alignItems="center" justifyContent="center">
                    <Button
                        variant='outlined'
                        size="small"
                        emed_tid="fil_clear"
                        onClick={() => {
                            setFilter({
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1
                            });
                            setTimeout(() => {
                                getCorporateList();
                            }, 500);
                        }}
                        id="eMed_Config_btn"
                    >
                        {t("Clear")}
                    </Button>
                    <Button
                        variant='contained'
                        size="small"
                        emed_tid="fil_search"
                        onClick={() => {
                            getCorporateList();
                            setFilter(prev => ({ ...prev, openFilter: false }));
                        }}
                        id="eMed_Config_btn"
                    >
                        {t("Search")}
                    </Button>
                </Stack>
            </Box>
        );
    };

    const gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(Filter.fromDate) },
            { label: "To Date", value: formatDate(Filter.toDate) },
        ]
        var ExportData = [];
        CorporateData?.length > 0 && CorporateData.map((item) => {
            const CorpData = {
                "Corporate Provider": item?.company_name,
                "No Of Admissions": item?.count,
                "Received Amount": item?.credit_paid,
                "Outstanding Amount": item?.pending_amount,
            };
            ExportData.push(CorpData);
        });
        return (
            <Box>
                <CommonGridToolBarWithFilterTextCustom data={ExportData} title={"Corporate Provider"} FilterTextArray={TextArray} filename={"Corporate Provider"} />
            </Box>
        )
    }

    const renderTable = () => {
        CorporateData.forEach((element, index) => {
            let page = currentPage
            let serial = (page * pageSize) + (index + 1)
            element.serial = serial
        })
        const columns = [
            { field: 'sno', headerName: 'S.No', flex: 0.01 },
            {
                field: 'company_name', headerClassName: 'grid--header', headerName: t('Corporate Provider'), flex: 0.23, sortable: false,
                renderCell: (params) => (<div>{params?.row?.company_name?.length > 33 ? <Tooltip placement="top" title={params?.row?.company_name} arrow>{params?.row?.company_name.slice(0, 30) + "..."}</Tooltip> : params?.row?.company_name || "-"}</div>)
            },
            {
                field: 'count', headerClassName: 'grid--header', headerName: t('No Of Admissions'), flex: 0.11, sortable: false, type: "number",
                renderCell: (params) => (<div>{params?.row?.count || "-"}</div>)
            },
            // {
            //     field: 'claim_amount', headerClassName: 'grid--header', headerName: `${t("Claim Amount")} (${CurrencySymbol})`, flex: 0.18, sortable: false, type: "number",
            //     renderCell: (params) => (<div>{AmountFormat(params?.row?.claim_amount || 0).replace(`${CurrencySymbol}`, "")}</div>)
            // },
            {
                field: 'credit_paid', headerClassName: 'grid--header', headerName: `${t("Received Amount")} (${CurrencySymbol})`, flex: 0.18, sortable: false, type: "number",
                renderCell: (params) => (<div>{AmountFormat(params?.row?.credit_paid || 0).replace(`${CurrencySymbol}`, "")}</div>)
            },
            {
                field: 'pending_amount', headerClassName: 'grid--header', headerName: `${t("Outstanding Amount")} (${CurrencySymbol})`, flex: 0.18, sortable: false, type: "number",
                renderCell: (params) => (<div>{params?.row?.pending_amount ? (AmountFormat(params?.row?.pending_amount || 0).replace(`${CurrencySymbol}`, "")) : '0'}</div>)
            },
            {
                field: 'actions', headerClassName: 'grid--header', headerName: t('Action'), type: 'actions', flex: 0.105, sortable: false, hideable: false,
                renderCell: (cellvalues) => (
                    <>
                        {/* <Tooltip title={t("Print")} placement="top" arrow>
                        <div>
                            <Button emed_tid="Print_invoice" className='eMed_usrconf_btn' disabled={states.disableBtn} onClick={() => { getCorpDetailedBillPrint(cellvalues?.id) }}>
                                <img src={ImagePaths.PrintIcons.default} alt="cart" className='eMed_action_img' />
                            </Button>
                        </div>
                    </Tooltip> */}
                        <Tooltip title={t("Payback")} placement="top" arrow>
                            <IconButton disabled={!CheckAccessFunc("Front Office", "Settlement", "Corporate Provider", "Credit Payment", "SubTab")?.editAccess} size="small" sx={{ borderRadius: "0.3vw" }} onClick={(event) => handleView(event, cellvalues)}>
                                <img className="emedhub_vendor_img2" src={ImagePaths.Wallet.default} alt="Wallet" />
                            </IconButton>
                        </Tooltip>
                    </>
                )
            }
        ];
        return (
            <div id="emedhub_ventor_Table" style={{ margin: "0vw 1vw", height: "63vh" }}>
                <DataGrid
                    rows={CorporateData}
                    columns={columns}
                    hideFooterSelectedRowCount
                    getRowId={(row) => row?.sno}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "53vh" }}>
                                {t("NoRecordsFound")}
                            </Stack>
                        )
                    }}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    onCellClick={handleCellClick}
                    onRowClick={handleCellClick}
                    page={currentPage}
                    loading={isLoader}
                    onPageChange={(newPage) => setCurrentPage(newPage)}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                />
            </div>
        )
    }

    return (
        <Box className="emedhub__purchase_page" sx={{ '& .grid--header': { backgroundColor: '#FAF9F9' } }}>
            <Box className='eMed_Pharma_rts_header'>
                <Box flex={0.8} display="flex">
                    {AmountsCard("Total Count", states.totalCount, true, "white", false, null)}
                    {/* {AmountsCard("Total Claim ", states.totalClaimAmount, false, "white", false, null)} */}
                    {AmountsCard("Total Received", states.totalReceivedAmount, false, "white", false, null)}
                    {AmountsCard("Total OutStanding", states.totalOutstanding, false, "white", false, null)}
                </Box>
                <Box flex={0.2} display="flex" justifyContent="flex-end" alignItems="center" marginRight="0.5vw">
                    <Tooltip title="Filter" placement='top' arrow>
                        <Button className='eMed_usrconf_btn' onClick={() => { setFilter(prev => ({ ...prev, openFilter: true })) }}>
                            <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                        </Button>
                    </Tooltip>
                    {/* <Tooltip title={t("Export")} placement="top" arrow>
                        <Button onClick={getCorpPaymentexcel} disabled={states.disableBtn} className='eMed_usrconf_btn'>
                            <img src={ImagePaths.ExportIcon.default} alt="upload" className='eMed_action_img' />
                        </Button>
                    </Tooltip> */}
                    {/* <Tooltip title="Print" placement="top" arrow>
                        <Button emed_tid="vndpay_print" className="eMed_usrconf_btn" disabled={states.disableBtn} onClick={printCorpPaymentList}>
                            <img src={ImagePaths.LabPrintIcon.default} alt="print" className="eMed_action_img" style={{ height: '2.3vw', width: '2.3vw' }} />
                        </Button>
                    </Tooltip> */}
                </Box>
            </Box>
            {renderTable()}
            <Drawer
                anchor={'right'}
                open={Filter.openFilter}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
        </Box>
    );
};

export default CorporateProvider;
